import { SenderPatientRelationship } from "../process/base-request.model";

export class RequestToVerifyUpdateModel{
    idPacientePhr: number;
    tipoRelacionPacienteUsuario: SenderPatientRelationship;
    workflowPosition: number;
    esUsuarioNuevo: string;
    idUsuario: number;
    nombreUsuario: string;
}